module.exports = __webpack_public_path__ + "static/media/02.34021029.mp3";